import styled from 'styled-components';

import { colors } from '@alixpartners/ui-components';
import noDataImage from 'assets/images/no-data.png';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
`;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  margin-top: 22px;
  background-image: url(${noDataImage});
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 384px;
  min-width: 384px;
`;

export const TextContainer = styled.div`
  max-width: 500px;
  margin-top: -38px;
`;

export const Title = styled.div`
  color: ${colors.grey7};
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 40px;
  line-height: 46px;
  text-align: center;
  letter-spacing: 0.3px;
`;

export const Text = styled.div`
  color: ${colors.grey5};
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 27px;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0;
  justify-content: center;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
